import SubHeading from "../../../atoms/SubHeading";
import InmuebleDocsList from "./InmuebleDocsList";

const ArchivoPermanenteTable = ({ data, refetch, loading }) => {

    return (
        <>
            <SubHeading text="Editar información (Para editar documentos haga click en cada uno)" color="black" />
            <InmuebleDocsList data={data} refetch={refetch} />
        </>
    );
};

export default ArchivoPermanenteTable;
